import Qs from "qs";
import { endOfDay, startOfDay, subDays } from "date-fns";
import { parseUrlDateTime } from "utilities/parse-url-date-time";
export const DEFAULT_DAY_RANGE = 14;

/**
 * The user can choose dates etc. but these will be the default selected.
 * @param search URL query parameters.
 */
export const getDefaultFilters = (search: string) => {
    const options = { ignoreQueryPrefix: true };
    const { endDateTime, startDateTime } = Qs.parse(search, options);
    return {
        endDateTime: parseUrlDateTime(endDateTime, endOfDay(subDays(new Date(), 1))),
        startDateTime: parseUrlDateTime(startDateTime, startOfDay(subDays(new Date(), DEFAULT_DAY_RANGE))),
    };
};

/**
 * Check if there is an agent filter in the URL.
 * @param search URL query string.
 * @returns      True only if an agent has been selected.
 */
export const isReviewAgentInUrl = (search: string) => {
    return "reviewAgentId" in Qs.parse(search, { ignoreQueryPrefix: true });
};
